<style scoped="true">
.form-control {
  color: #333;
}

.input-group > .form-control {
  padding-left: 5px;
  font-size: 0.93rem;
}
</style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Nueva revision" />
        <b-container class="mb-3">
          <b-row class="mb-3">
            <b-col cols="12">
              <b-button-toolbar justify>
                <b-button
                  variant="default"
                  @click.stop="navigateBack()"
                  size="sm"
                >
                  <b-icon-chevron-left scale="1.75" />
                </b-button>
              </b-button-toolbar>
            </b-col>
          </b-row>
          <b-form>
            <b-form-group label="Nombre del checklist">
              <b-form-input
                v-model="name"
                type="text"
                required
                debounce="500"
                placeholder="Nombre del checklist"
              ></b-form-input>
            </b-form-group>
          </b-form>
          <b-tabs>
            <b-tab
              class="flex-column"
              v-for="(questions, category) in categories"
              :key="category"
              lazy
            >
              <template v-slot:title>
                <div>
                  <span>{{ category }}</span>
                  <b-button
                    class="ml-2"
                    size="sm"
                    @click="editCategory(category)"
                  >
                    <b-icon-pencil scale="1" />
                  </b-button>
                  <b-button
                    size="sm"
                    @click="deleteCategory(category)"
                    variant="danger"
                  >
                    <b-icon-trash scale="1" />
                  </b-button>
                </div>
              </template>
              <RevisionQuestions :category="category" class="mt-1" />
            </b-tab>
            <template v-slot:tabs-end>
              <b-nav-item role="presentation" href="#" @click="addCategory">
                <b-icon-plus scale="1.3" variant="dark"></b-icon-plus>
              </b-nav-item>
            </template>
            <template v-slot:empty>
              <div class="text-center">
                Agregue una categoria para empezar.
              </div>
            </template>
          </b-tabs>
          <b-row class="mt-3">
            <b-col cols="12">
              <b-button
                variant="success"
                class="float-right"
                @click="uploadNewRevision()"
              >
                <b-icon-cloud-upload scale="1.4" />
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </main>
    </section>
    <b-modal
      id="category-name-form"
      centered
      title="Entre el nombre de la categoria"
      button-size="sm"
      footer-class="p-2 border-top-0"
      body-class="p-3"
      header-class="border-bottom-0"
      @hidden="cancelEdit"
      @ok="changeCategoryName"
    >
      <b-form-input v-model="editingName" type="text"></b-form-input>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Header from "../../Header";
import RevisionQuestions from "./Questions";

export default {
  name: "RevisionForm",
  components: {
    Header,
    RevisionQuestions,
  },
  async created() {
    const { templateId } = this.$route.params;
    if (templateId) {
      // its creating a new revision from an existing template
      const templateRevisionsPromise = this.fetchRevisions({ templateId });

      const startFromScratch = await this.$bvModal.msgBoxConfirm(
        "Para crear una nueva revision, usted puede empezar de la revision anterior o empezar con una revision completamente nueva. ¿Desea empezar una revision completamente nueva?",
        {
          size: "sm",
          buttonSize: "sm",
          okTitle: "Si",
          cancelTitle: "No",
          centered: true,
          footerClass: "p-2 border-top-0",
        }
      );

      // we can load this in the background while we wait from user's answer
      await templateRevisionsPromise;

      this.setTemplateId({ templateId });
      const latestRevision = this.getLatestRevision(templateId);
      if (!startFromScratch) {
        this.setFromTemplate({ template: latestRevision });
      } else {
        this.setName({ name: latestRevision.name });
      }

      this.name = this.getRevisionName();
      this.categories = this.getCategories();
    }
  },
  data() {
    return {
      addingCategory: true,
      editingName: "",
      currentlyEditing: "",
      categories: {},
      name: "",
    };
  },
  computed: {
    ...mapGetters("templates", ["getLatestRevision"]),
  },
  methods: {
    ...mapActions("templates", ["fetchRevisions"]),
    ...mapActions("revision", ["setFromTemplate", "createRevision"]),
    ...mapGetters("revision", ["getRevisionName", "getCategories"]),
    ...mapMutations("revision", {
      createCategory: "ADD_CATEGORY",
      renameCategory: "RENAME_CATEGORY",
      removeCategory: "REMOVE_CATEGORY",
      setName: "SET_NAME",
      setTemplateId: "SET_TEMPLATE_ID",
    }),
    navigateBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    isEditing(category) {
      return this.currentlyEditing === category;
    },
    addCategory() {
      this.addingCategory = true;
      this.$bvModal.show("category-name-form");
    },
    editCategory(category) {
      this.addingCategory = false;
      this.currentlyEditing = category;
      this.editingName = category;
      this.$bvModal.show("category-name-form");
    },
    async deleteCategory(category) {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        `La categoria "${category}" y sus preguntas serán borradas. ¿Desea continuar?`,
        {
          size: "sm",
          buttonSize: "sm",
          okTitle: "Si",
          cancelTitle: "Cancelar",
          centered: true,
          footerClass: "p-2 border-top-0",
        }
      );

      if (!confirmation) {
        return;
      }

      this.removeCategory({ name: category });
      this.categories = { ...this.getCategories() };
    },
    changeCategoryName() {
      if (
        (!this.addingCategory &&
          (this.currentlyEditing === "" ||
            this.editingName === "" ||
            this.currentlyEditing === this.editingName)) ||
        (this.addingCategory && this.editingName === "")
      ) {
        this.cancelEdit();
        return;
      }

      if (this.addingCategory) {
        this.createCategory({ name: this.editingName });
      } else {
        this.renameCategory({
          oldName: this.currentlyEditing,
          newName: this.editingName,
        });
      }

      this.cancelEdit();
      this.categories = { ...this.getCategories() };
    },
    cancelEdit() {
      this.currentlyEditing = "";
      this.editingName = "";
    },
    async uploadNewRevision() {
      try {
        await this.createRevision();
        this.navigateBack();
      } catch (err) {
        // TODO: show error
      }
    },
  },
  watch: {
    name() {
      this.setName({ name: this.name });
    },
  },
};
</script>
